import React from "react";
import { Container, Card, CardBody, Row, Col } from "reactstrap";
import { FaInfoCircle, FaFileAlt, FaUserTie, FaPhoneAlt } from "react-icons/fa";

const WelcomeLetter = () => {
  return (
    <Container className="py-5" style={{ maxWidth: "800px" }}>
      <Card className="border-0 shadow-sm rounded-4">
        <CardBody className="p-5">
          {/* Header */}
          <div className="text-center mb-5">
            <h2 className="fw-bold text-primary">Rehoboth Institute of Nursing</h2>
            <hr className="w-25 mx-auto border-primary border-2" />
            <h5 className="text-muted">Academic Year 2026–27</h5>
          </div>

          {/* Introduction */}
          <div className="mb-4">
            <p className="lead">Dear Parents, Guardians, and Students,</p>
            <p>The Rehoboth family extends a heartfelt welcome to our incoming students. We deeply value your ongoing support and trust as we embark on this new academic journey together.</p>
          </div>

          {/* Info Grid */}
          <Row className="g-4 mb-4">
            <Col md={6}>
              <div className="p-3 bg-light rounded-3">
                <h6 className="text-primary"><FaInfoCircle className="me-2" /> Reporting Date</h6>
                <p className="small">September 5th to 15th. Precise dates to follow.</p>
              </div>
            </Col>
            <Col md={6}>
              <div className="p-3 bg-light rounded-3">
                <h6 className="text-primary"><FaInfoCircle className="me-2" /> Class Hours</h6>
                <p className="small">Monday to Saturday<br/>9:00 AM – 4:00 PM</p>
              </div>
            </Col>
          </Row>

          {/* Requirements Section */}
          <div className="mb-4">
            <h5 className="text-success mb-3"><FaFileAlt className="me-2" /> Documents Required</h5>
            <ul className="list-unstyled ps-3">
              <li>✓ Original SSLC, +1, and +2 Certificates</li>
              <li>✓ Original T.C and Migration Certificate</li>
              <li>✓ Conduct Certificate</li>
              <li>✓ 5 Passport Size Photographs</li>
              <li>✓ Copy of [ID Card Redacted]</li>
            </ul>
          </div>

          {/* Contact Section */}
          <div className="mt-5 border-top pt-4">
            <h5 className="mb-3"><FaUserTie className="me-2" /> Key Contacts</h5>
            <Row className="g-3">
              <Col md={6}>
                <p className="mb-1 fw-bold">Admission Queries</p>
                <p className="small">Mr. Sibi Alexander: 9448020269<br/>Mr. Anil Mathew: 9036813816</p>
              </Col>
              <Col md={6}>
                <p className="mb-1 fw-bold">Academic Coordinators</p>
                <p className="small">Mrs. Soumya G (BSc): 7829685714<br/>Mrs. Sminu Susan (GNM): 8593936815</p>
              </Col>
              <Col md={12} className="mt-2">
                <p className="mb-1 fw-bold"><FaPhoneAlt className="me-2" /> Administrative Contacts</p>
                <p className="small">Mrs. Renju: 9740350269<br/>Mr. Sanoj: 9740350269</p>
              </Col>
            </Row>
          </div>

          {/* Footer */}
          <div className="mt-5 text-end">
            <p className="mb-0">Warm Regards,</p>
            <p className="fw-bold text-primary">Administration</p>
            <p className="small text-muted">Rehoboth Institute of Nursing</p>
          </div>
        </CardBody>
      </Card>
    </Container>
  );
};

export default WelcomeLetter;